import { useHotkeys } from 'react-hotkeys-hook';

import { Hotkey } from 'config/enums';
import { useAppDispatch } from 'features/app/hooks';
import { handleResetCall } from 'features/call/call-base/store';
import { resetCallComments } from 'features/call/vrs-call-comments/store';
import { leaveQueue } from 'features/leave-queue/store';
import { resetSessionId } from 'features/session/store';

export const useLeaveQueue = () => {
  const dispatch = useAppDispatch();

  const handleLeaveQueue = () => {
    dispatch(handleResetCall()).unwrap();
    dispatch(resetSessionId());
    dispatch(resetCallComments());
    dispatch(leaveQueue({ shouldFinishSession: true }));
  };

  useHotkeys(
    Hotkey.LeaveTheQueue,
    () => {
      handleLeaveQueue();
    },
    [handleLeaveQueue]
  );

  return { handleLeaveQueue };
};
